import React from 'react'
import PropTypes from 'prop-types'

// core components
import AtlasGrid from '../../components/AtlasGrid/AtlasGrid.js'

// material-ui components
import LinearProgress from '@material-ui/core/LinearProgress'

// Helper to generate the headings
import { productHeadings } from './Headings/ProductHeadings.js'

// report components
import { getProducts } from '../../layouts/Aws.js'

export default function Products ({ siteId }) {
  const [isLoading, setLoading] = React.useState(true)

  const [gridHeadings, setGridHeadings] = React.useState([])
  const [gridData, setGridData] = React.useState([])

  const columnTypes = {
    numberColumn: {
      width: 130,
      filter: 'agNumberColumnFilter'
    },
    medalColumn: {
      width: 100,
      columnGroupShow: 'open',
      filter: false
    },
    nonEditableColumn: { editable: false },
    dateColumn: {
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: function (filterLocalDateAtMidnight, cellValue) {
          var dateParts = cellValue.split('/')
          var day = Number(dateParts[0])
          var month = Number(dateParts[1]) - 1
          var year = Number(dateParts[2])
          var cellDate = new Date(year, month, day)
          if (cellDate < filterLocalDateAtMidnight) {
            return -1
          } else if (cellDate > filterLocalDateAtMidnight) {
            return 1
          } else {
            return 0
          }
        }
      }
    }
  }

  const updateData = (data) => {
    setGridData(data)
    setLoading(false)
  }

  React.useEffect(() => {
    setGridHeadings(productHeadings(false))

    setLoading(true)

    const data = {
      siteId: siteId
    }

    getProducts(data).then(res => {
      updateData(res)
    })
  }, [])

  return (
    <>
      {
        isLoading
          ? <LinearProgress />
          : <AtlasGrid
            columnHeadings={gridHeadings}
            rowData={gridData}
            columnTypes={columnTypes}
          />
      }
    </>
  )
}

Products.propTypes = {
  siteId: PropTypes.string.isRequired
}
